import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import UserDefaultImage from "../../../assets/images/UserDefultImage.png";
import SubHeaderMenu from "../../Sidebar/SubHeaderMenu";
import MerchantBusiness from "./MerchantBusiness";
import MerchantPersonalInfo from "./MerchantPersonalInfo";
import MerchantBankDetails from "./MerchantBankDetails";
import MerchantDocument from "./MerchantDocument";


const MerchantOverviewDetail = () => {
  const [profileData, setProfileData] = useState([]);
  const [activeTab, setActiveTab] = useState(0); 
  const[loading , setLoading] = useState(false)
  const location = useLocation();
  const data = location?.state;

  useEffect(() => {
    setProfileData(data);
  }, [data]);

  const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG;
  const userImage = profileData?.profileImage
    ? typeof profileData?.profileImage === "object"
      ? URL.createObjectURL(profileData?.profileImage)
      : `${BASE_URL_IMG}/${profileData?.profileImage}`
    : UserDefaultImage;

  const tabs = [
    {
      title: "Personal Info",
      content: <MerchantPersonalInfo profileData={profileData} />,
    },
    {
      title: "My Business",
      content: <MerchantBusiness profileData={profileData} />,
    },
    {
      title: "Bank Details",
      content: <MerchantBankDetails profileData={profileData} />,
    },
    {
      title: "Document",
      content: <MerchantDocument profileData={profileData} />,
    },
  ];

  return (
    <div id="main" className="p-4">
      <h1 className="font-bold text-2xl text-slate-900 pb-5">
        <span>Merchant Management</span> /
        <span className="text-red-500">
          <SubHeaderMenu location={location} />
        </span>
      </h1>

      <div className="p-6 xl:flex justify-between lg:flex md:flex sm:flex">
        <div className="xl:flex lg:flex md:flex sm:flex items-center">
          <div className="relative w-20 h-20 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600">
            <img src={userImage} alt="Profile" />
          </div>
          <div className="ps-4">
            <h3 className="text-xl font-bold text-gray-900">
              {`${profileData?.firstName || "N/A"} ${profileData?.lastName || ""}`}
            </h3>
            <h6 className="text-md font-semibold text-gray-600 pt-1">
              {profileData?.businessDetils?.shopName || "N/A"}
            </h6>
            <p className="text-sm text-gray-400 pt-1">{profileData?.city || "N/A"}</p>
          </div>
        </div>

        <div className="pt-5 xl:pt-0 lg:pt-0">
          {/* QRCode Component can be added here if needed */}
        </div>
      </div>

      <div>
        {/* Tabs Navigation */}
        <div className="flex border-b border-gray-200 mb-4">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`px-4 py-2 font-semibold text-sm ${
                activeTab === index
                  ?  "border-b-2 border-custom-red text-custom-red bg-custom-red2 rounded-t-md"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab(index)}
            >
              {tab.title}
            </button>
          ))}
        </div>

        {/* Active Tab Content */}
        <div>{tabs[activeTab].content}</div>
      </div>
    </div>
  );
};

export default MerchantOverviewDetail;
